/* eslint-disable no-undef */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { MoreNavLinkStyle } from './MoreNavLinks.styled';
import { sideNavLinksWCMSLinks } from 'src/constants/wcmsRedirectionLinks';
import { useTranslation } from 'react-i18next';
import {
    CC_USER_ROLE,
    ITA_USER_ROLE,
    CSR_USER_ROLE,
    FIM_USER_ROLE,
    FIA_USER_ROLE,
} from 'src/constants/appConstants';
import {
    checkImpersonationActive,
    checkProxyActive,
    getRoutePathWithParams,
} from 'src/utils/util';
import { setTemplateChangeDetails } from 'src/pages/more/pages/templates/redux/action/index.js';
import { getConfigurations } from 'src/common/redux/actions';
import {
    actionResetOrderList,
    resetOrderListFilter,
    resetAppliedOrderListFilter,
} from 'src/pages/orders/redux/actions';
import { PROXY } from '../../../constants/appConstants';

//Updated this component as a forwardRef component to fix
//Function components cannot be given refs console error
// eslint-disable-next-line react/display-name
const MoreNavLinks = React.forwardRef((props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const { employeeRole } = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    const {
        accounts,
        alerts,
        announcements,
        dashboard,
        reactDashboard,
        links,
        orderHistory,
        physicians,
        proxies,
        // productGuide,
        settings,
        templates,
        legacyMobile,
    } = useSelector((state) => state.loginReducer.moreVisibility);
    return (
        <>
            {accounts && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'accounts'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_ACCOUNTS
                                ? '/accounts'
                                : sideNavLinksWCMSLinks.accounts,
                            'accounts'
                        );
                        props.selectedOption('accounts');
                    }}
                >
                    <NavLink
                        to="/accounts"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_ACCOUNTS
                                    ? '/accounts'
                                    : sideNavLinksWCMSLinks.accounts,
                                'accounts'
                            );
                            props.selectedOption('accounts');
                        }}
                    >
                        {t('moreNavLink.accountsLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {alerts && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'alerts'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            sideNavLinksWCMSLinks('alerts'),
                            'alerts'
                        );
                        props.selectedOption('alerts');
                    }}
                >
                    <NavLink
                        to="/alerts"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                sideNavLinksWCMSLinks('alerts'),
                                'alerts'
                            );
                            props.selectedOption('alerts');
                        }}
                    >
                        {t('moreNavLink.alertsLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {announcements && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'announcements'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_ANNOUNCEMENTS
                                ? '/announcements'
                                : sideNavLinksWCMSLinks('announcements'),
                            'announcements'
                        );
                        props.selectedOption('announcements');
                    }}
                >
                    <NavLink
                        to="/announcements"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_ANNOUNCEMENTS
                                    ? '/announcements'
                                    : sideNavLinksWCMSLinks('announcements'),
                                'announcements'
                            );
                            props.selectedOption('announcements');
                        }}
                    >
                        {t('moreNavLink.announcementsLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {dashboard &&
                ((employeeRole &&
                    (employeeRole === FIM_USER_ROLE ||
                        employeeRole === FIA_USER_ROLE ||
                        employeeRole === ITA_USER_ROLE) &&
                    !checkProxyActive() &&
                    !checkImpersonationActive()) ||
                    ((checkImpersonationActive() || checkProxyActive()) &&
                        (sessionStorage.getItem('ProxyUserRole') ===
                            FIA_USER_ROLE ||
                            sessionStorage.getItem('ProxyUserRole') ===
                            FIM_USER_ROLE ||
                            sessionStorage.getItem('ProxyUserRole') ===
                            ITA_USER_ROLE))) && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'fieldInventoryDashboard'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            reactDashboard
                                ? '/fieldInventoryDashboard'
                                : sideNavLinksWCMSLinks('fieldInventoryDashboard'),
                            'fieldInventoryDashboard'
                        );
                        props.selectedOption('fieldInventoryDashboard');
                    }}
                >
                    <NavLink
                        to="/fieldInventoryDashboard"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                reactDashboard
                                    ? '/fieldInventoryDashboard'
                                    : sideNavLinksWCMSLinks('fieldInventoryDashboard'),
                                'fieldInventoryDashboard'
                            );
                            props.selectedOption('fieldInventoryDashboard');
                        }}
                    >
                        {t('moreNavLink.fieldInventoryDashboardLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
                )}
            {links && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'links'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_LINKS
                                ? '/links'
                                : sideNavLinksWCMSLinks('links'),
                            'links'
                        );
                        props.selectedOption('links');
                    }}
                >
                    <NavLink
                        to="/links"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_LINKS
                                    ? '/links'
                                    : sideNavLinksWCMSLinks('links'),
                                'links'
                            );
                            props.selectedOption('links');
                        }}
                    >
                        {t('moreNavLink.linkLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {orderHistory && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'orderHistory'}
                    onClick={(e) => {
                        props.handleClose();
                        const wasOnOrderHistory =
                            history.location.pathname === '/orderHistory';
                        dispatch(actionResetOrderList());
                        dispatch(resetOrderListFilter());
                        dispatch(resetAppliedOrderListFilter());
                        props.navigateWithBusinessLogic(
                            e,
                            '/orderHistory',
                            'orderHistory'
                        );
                        props.selectedOption('orderHistory');
                        if (wasOnOrderHistory) {
                            history.push(
                                getRoutePathWithParams('/orderHistory')
                            );
                        }
                    }}
                >
                    <NavLink
                        to="/orderHistory"
                        onClick={(e) => {
                            dispatch(actionResetOrderList());
                            dispatch(resetOrderListFilter());
                            dispatch(resetAppliedOrderListFilter());
                            props.navigateWithBusinessLogic(
                                e,
                                '/orderHistory',
                                'orderHistory'
                            );
                            props.selectedOption('orderHistory');
                        }}
                    >
                        {t('moreNavLink.orderHistoryLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {physicians && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'physicians'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_PHYSICIANS
                                ? '/physicians'
                                : sideNavLinksWCMSLinks('physicians'),
                            'physicians'
                        );
                        props.selectedOption('physicians');
                    }}
                >
                    <NavLink
                        to="/physicians"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_PHYSICIANS
                                    ? '/physicians'
                                    : sideNavLinksWCMSLinks('physicians'),
                                'physicians'
                            );
                            props.selectedOption('physicians');
                        }}
                    >
                        {t('moreNavLink.physiciansLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {proxies && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'proxies'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_PROXIES
                                ? '/proxies'
                                : sideNavLinksWCMSLinks('proxies'),
                            'proxies'
                        );
                        props.selectedOption('proxies');
                        dispatch(getConfigurations({ resourceType: 'visibility', module: PROXY}, PROXY));
                    }}
                >
                    <NavLink
                        to="/proxies"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_PROXIES
                                    ? '/proxies'
                                    : sideNavLinksWCMSLinks('proxies'),
                                'proxies'
                            );
                            props.selectedOption('proxies');
                        }}
                    >
                        {t('moreNavLink.proxiesLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
            )}
            {settings &&
                // (
                //     (employeeRole &&
                //         !checkProxyActive() &&
                //         !checkImpersonationActive()) ||
                //     ((checkImpersonationActive() || checkProxyActive()) &&
                //         sessionStorage.getItem('ProxyUserRole') !==
                //         CC_USER_ROLE &&
                //         sessionStorage.getItem('ProxyUserRole') !==
                //         ITA_USER_ROLE &&
                //         sessionStorage.getItem('ProxyUserRole') !==
                //         CSR_USER_ROLE)) && (
                    (<MoreNavLinkStyle
                        isBackground={props.activeLabel === 'settings'}
                        onClick={(e) => {
                            props.handleClose();
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_SETTINGS
                                    ? '/settings'
                                    : sideNavLinksWCMSLinks('settings'),
                                'settings'
                            );
                            props.selectedOption('settings');
                        }}
                    >
                        <NavLink
                            to="/settings"
                            onClick={(e) => {
                                props.navigateWithBusinessLogic(
                                    e,
                                    process.env.ENABLE_SETTINGS
                                        ? '/settings'
                                        : sideNavLinksWCMSLinks('settings'),
                                    'settings'
                                );
                                props.selectedOption('settings');
                            }}
                        >
                            {t('moreNavLink.settingsLabel')}
                        </NavLink>
                    </MoreNavLinkStyle>
                )}
            {/* {productGuide && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'productGuide'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_PRODUCT_GUIDE
                                ? '/productGuide'
                                : sideNavLinksWCMSLinks('productGuide'),
                            'productGuide'
                        );
                        props.selectedOption('productGuide');
                    }}
                >
                    <NavLink
                        to="/productGuide"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_PRODUCT_GUIDE
                                    ? '/productGuide'
                                    : sideNavLinksWCMSLinks('productGuide'),
                                'productGuide'
                            );
                            props.selectedOption('productGuide');
                            dispatch(clearProductsGuideData());
                        }}
                    >
                        Product Guide
                    </NavLink>
                </MoreNavLinkStyle>
            )} */}

            {templates &&
                ((employeeRole &&
                    employeeRole !== FIM_USER_ROLE &&
                    employeeRole !== FIA_USER_ROLE &&
                    !checkImpersonationActive() &&
                    !checkProxyActive()) ||
                    ((checkImpersonationActive() || checkProxyActive()) &&
                        sessionStorage.getItem('ProxyUserRole') !==
                        FIM_USER_ROLE &&
                        sessionStorage.getItem('ProxyUserRole') !==
                        FIA_USER_ROLE)) && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'templates'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            process.env.ENABLE_TEMPLATES
                                ? '/templates'
                                : sideNavLinksWCMSLinks('templates'),
                            'templates'
                        );
                        props.selectedOption('templates');
                    }}
                >
                    <NavLink
                        to="/templates"
                        onClick={(e) => {
                            // dispatch(
                            //     setTemplateChangeDetails({
                            //         pageName: '',
                            //     })
                            // );
                            props.navigateWithBusinessLogic(
                                e,
                                process.env.ENABLE_TEMPLATES
                                    ? '/templates'
                                    : sideNavLinksWCMSLinks('templates'),
                                'templates'
                            );
                            props.selectedOption('templates');
                            // dispatch(getConfigurations({
                            //     resourceType: 'PROCESS',
                            //     module: TEMPLATES,
                            // }, TEMPLATES));
                        }}
                    >
                        {t('moreNavLink.templatesLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
                )}
            {legacyMobile &&
                ((employeeRole &&
                    ![CC_USER_ROLE, ITA_USER_ROLE, CSR_USER_ROLE].includes(
                        employeeRole
                    ) &&
                    !checkImpersonationActive() &&
                    !checkProxyActive()) ||
                    ((checkImpersonationActive() || checkProxyActive()) &&
                        ![CC_USER_ROLE, ITA_USER_ROLE, CSR_USER_ROLE].includes(
                            sessionStorage.getItem('ProxyUserRole')
                        ))) && (
                <MoreNavLinkStyle
                    isBackground={props.activeLabel === 'mycaseLegacy'}
                    onClick={(e) => {
                        props.handleClose();
                        props.navigateWithBusinessLogic(
                            e,
                            sideNavLinksWCMSLinks('mycaseMobile'),
                            'mycaseMobile'
                        );
                        props.selectedOption('mycaseLegacy');
                    }}
                >
                    <NavLink
                        to="/mycase-mobile"
                        onClick={(e) => {
                            props.navigateWithBusinessLogic(
                                e,
                                sideNavLinksWCMSLinks('mycaseMobile'),
                                ''
                            );
                            props.selectedOption('mycaseLegacy');
                        }}
                    >
                        {t('moreNavLink.legayMycaseMobileLabel')}
                    </NavLink>
                </MoreNavLinkStyle>
                )}
        </>
    );
});

export default MoreNavLinks;
